import { Directive } from '@angular/core';

@Directive({ selector: '[nextButton]' })
export class NextButtonDirective {}
